import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { createAppFlyoutAnchor } from 'owa-command-ribbon';
import type { MenuDefinition } from '@1js/acui-menu/lib/components/MenuDefinition';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { getComposeRibbonId } from 'owa-editor/lib/utils/getComposeRibbonId';
import type { IButtonStyles } from '@fluentui/react';
import { ActionControlId } from 'owa-ribbon-ids';
import { sensitivity_FlyoutButton_ActionControl } from '../../utils/actionControlStrings.locstring.json';
import Classification from 'owa-fluent-icons-svg/lib/icons/ClassificationRegular';
import loc from 'owa-localize';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getHoverTooltip } from '../../utils/HoverTooltips/getHoverTooltip';
import type { IKeytipProps } from '@fluentui/react/lib/Keytip';

export const getSensitivityMenu = computedFn(
    (
        viewState: EditorViewState | undefined,
        menuDefinition: MenuDefinition,
        keytips: IKeytipProps,
        styles: IButtonStyles | undefined
    ): RibbonControlProps => {
        const sensitivityText = loc(sensitivity_FlyoutButton_ActionControl);
        return createAppFlyoutAnchor(
            getComposeRibbonId(ActionControlId.Sensitivity, viewState),
            sensitivityText,
            menuDefinition,
            keytips,
            Classification,
            undefined,
            styles,
            {
                customTooltip: isFeatureEnabled('mon-ribbon-tooltips')
                    ? getHoverTooltip(ActionControlId.Sensitivity, sensitivityText)
                    : undefined,
            }
        );
    }
);
